import apiClient from "./client";
import type {
  LicenseProduct,
  ApiResponse,
  ListResponse,
  ProductQueryParams,
  ProductBatchUpdatePayload,
  ProductBatchDeletePayload,
} from "@/types";

const BASE = "/products";

export async function listProducts(
  params?: ProductQueryParams,
): Promise<ApiResponse<ListResponse<LicenseProduct>>> {
  const { data } = await apiClient.get(BASE, { params });
  return data;
}

export async function getProduct(
  id: number,
): Promise<ApiResponse<LicenseProduct>> {
  const { data } = await apiClient.get(`${BASE}/${id}`);
  return data;
}

export async function createProduct(form: {
  name: string;
  edition: string;
  identifier: string;
  feature_keys: string[];
  description?: string;
  project_id?: number;
  key_format: string;
  ed25519_pub: string;
  ed25519_priv?: string;
  hmac_secret?: string;
  is_active?: boolean;
}): Promise<ApiResponse<LicenseProduct>> {
  const { data } = await apiClient.post(BASE, form);
  return data;
}

export async function updateProduct(
  id: number,
  form: Partial<{
    name: string;
    edition: string;
    identifier: string;
    feature_keys: string[];
    description: string;
    project_id: number;
    key_format: string;
    ed25519_pub: string;
    ed25519_priv?: string;
    hmac_secret?: string;
    is_active: boolean;
  }>,
): Promise<ApiResponse<LicenseProduct>> {
  const { data } = await apiClient.put(`${BASE}/${id}`, form);
  return data;
}

export async function deleteProduct(id: number): Promise<ApiResponse<null>> {
  const { data } = await apiClient.delete(`${BASE}/${id}`);
  return data;
}

export async function updateProductBatch(
  data: ProductBatchUpdatePayload,
): Promise<ApiResponse<null>> {
  const { data: res } = await apiClient.patch(BASE, data);
  return res;
}

export async function deleteProductBatch(
  data: ProductBatchDeletePayload,
): Promise<ApiResponse<null>> {
  const { data: res } = await apiClient.delete(BASE, { data });
  return res;
}
